import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_FAKE_MENU_MUTATION } from '../graphql/mutations'
import { DELETE_FAKE_MENU } from '../redux/action-types'

const useDeleteFakeMenuMutation = () => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    id =>
      apolloService.mutate({
        mutation: DELETE_FAKE_MENU_MUTATION,
        variables: { id },
        dispatch,
        action: DELETE_FAKE_MENU,
      }),
    [dispatch],
  )

  return [mutate]
}

export default useDeleteFakeMenuMutation
